import { map } from 'rxjs/operators/map';
import { ZoneSerializer } from '../../models';
import ajax from '../../utils/ajax';

class ZoneService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  configurationPath = '/networkAsset/airfinder/zones';
  singlePath = '/networkAsset/airfinder/zone';

  /**
    Create a Zone
    @param {Object} zone Object to create
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the normalized response
  */
  create = (zone, store) => {
    return ajax({
        url: `${this.conductorUrl}${this.configurationPath}`,
        body: ZoneSerializer.serialize(zone),
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        responseType: 'json'
      },
      store
    ).pipe(map(data => ZoneSerializer.normalize(data.response)));
  };

  /**
    Delete a Zone
    @param {String} zoneId
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the response
  */
  delete = (zoneId, store) => {
    return ajax({
        url: `${this.conductorUrl}${this.singlePath}/${zoneId}`,
        body: '',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'DELETE',
        responseType: 'json'
      },
      store
    );
  };

  /**
      Update a Zone
      @param {String} zoneId
      @param {Object} store Redux store
      @returns {Observable} Observable that emits the response
    */
  update = (zone, store) => {
    let zoneid = zone.id;
    return ajax({
        url: `${this.conductorUrl}${this.singlePath}/${zoneid}`,
        body: ZoneSerializer.serializeForUpdate(zone),
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'PUT',
        responseType: 'json'
      },
      store
    ).pipe(map(data => ZoneSerializer.normalize(data.response)));
  };

  /**
    Get Zones in an area
    @param {String} areaId
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the list of normalized zones
  */
  getByAreaId = (areaId, store) => {
    return ajax({
        url: `${this.conductorUrl}${this.configurationPath}?areaId=${areaId}`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(map(data => data.response.map(ZoneSerializer.normalize)));
  };

  /**
    Get Zones in a site
    @param {String} siteId
    @param {Object} store Redux store
    @returns {Observable} Observable that emits the list of normalized zones
  */
  getBySiteId = (siteId, store) => {
    return ajax({
        url: `${this.conductorUrl}${this.configurationPath}?siteId=${siteId}`,
        method: 'GET',
        responseType: 'json'
      },
      store
    ).pipe(map(data => data.response.map(ZoneSerializer.normalize)));
  };
}

export default new ZoneService();


// WEBPACK FOOTER //
// ./src/services/zone/index.js